export var blue = "rgba(32, 41, 68, 1)";
export var deepBlue = "rgba(20, 25, 40, 1)";
export var fontColor = " rgba(231, 221, 30, 1)";
export var activeMenuColor = "rgba(20,24,39,1)";
export var borderColor = "gray";
export var grayBorder = "border: solid 1px gray;";
export var whiteFont = "white";
export var lightBlue = "rgba(50,60,86,1)";
export var grayFont = "color:gray";
//# sourceMappingURL=colors.js.map